import { render, staticRenderFns } from "./DetailProjectName.vue?vue&type=template&id=1c306f19&"
import script from "./DetailProjectName.vue?vue&type=script&lang=js&"
export * from "./DetailProjectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports